/**
 * Kiszámolja a kijelölt elem alapján a hint pozícióját
 * @param element object
 * @param config object
 * @param body object
 * @param hintOptions object
 */
import getElementProperties from './get-element-properties';

export default function calculateHintPosition(element, config, body, $document) {
	var elemOffset = getElementProperties(element);
	var tooltip = body.find('.hint-tooltip');
	var documentWidth = $document.width();


	if (elemOffset.left < config.tooltipWidth + config.paddingWidth) {
		tooltip.removeClass('arrow-left');
		tooltip.removeClass('arrow-right');
		tooltip.removeClass('arrow-top-center');
		if (elemOffset.left - config.pagePadding + elemOffset.width / 2 - config.tooltipWidth / 2 < 10) {
			tooltip.css({left: '10px'});
			tooltip.addClass('arrow-top-left');
		}		else {
			tooltip.css({left: elemOffset.left - config.pagePadding + elemOffset.width / 2 - config.tooltipWidth / 2 + 'px'});
			tooltip.addClass('arrow-top-center');
		}

		tooltip.css({
			top: elemOffset.top + elemOffset.height + config.paddingWidth + 'px'
		});


	} else if (elemOffset.left - config.pagePadding + elemOffset.width / 2 - config.tooltipWidth / 2 + config.tooltipWidth > documentWidth) {
		tooltip.removeClass('arrow-left');
		tooltip.removeClass('arrow-right');
		tooltip.removeClass('arrow-top-center');
		tooltip.css({
			left: 'auto',
			right: '10px'
		});
		tooltip.addClass('arrow-top-right');
	}
}
